module.exports = __webpack_public_path__ + "static/media/Morgan Dornbush.d34c923f.png";